module.exports = __webpack_public_path__ + "static/media/creativeMaterialsTesting-01.2a2bc30e.png";